<template>
  <div>
    <v-dialog
      v-model="showFileUpload"
      width="50%"
      scrollable
      persistent
    >
      <v-card class="image-upload">
        <v-card-title>
          Images
          <v-spacer />
          <v-tooltip
            left
            color="#7384db"
          >
            <input
              v-show="false"
              id="file_container"
              ref="fileInput"
              type="file"
              accept="image/*"
              class="bottom"
              multiple
              @change="onFilePicked"
            >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="my-0 mx-1"
                outlined
                @click="onPickFile"
                v-on="on"
              >
                <v-icon color="success">
                  mdi-cloud-upload
                </v-icon>
              </v-btn>
            </template>
            <span class="pa-2">Upload Files</span>
          </v-tooltip>
          <v-btn
            icon
            color="error"
            @click="close()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text
          style="height:300px"
          class="py-0"
        >
          <v-container
            v-if="filesList.length > 0"
            class="px-0 selected-files-cont"
          >
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col
                    v-for="(file, idx) in filesList"
                    :key="idx"
                    cols="12"
                    md="3"
                    xl="3"
                    class="d-flex child-flex"
                  >
                    <v-card
                      outlined
                      class="selected-file"
                    >
                      <div class="pa-2 center-content">
                        <h3>{{ file.fileInfo.name }}</h3>
                      </div>
                      <v-divider v-if="file.fileInfo.tags" />
                      <div
                        v-if="file.fileInfo.tags"
                        class="pa-2 center-content"
                        style="height:auto"
                      >
                        <span
                          style="line-height: 26px"
                          class="mr-1"
                        >Tags:</span>
                        <strong>{{ file.fileInfo.tags }}</strong>
                      </div>
                      <v-divider />
                      <div
                        class="pa-2 center-content"
                        style="height:auto"
                      >
                        <v-spacer />
                        <v-btn
                          x-small
                          color="error"
                          outlined
                          class="mr-2"
                          @click="removeSelected()"
                        >
                          Remove
                        </v-btn>
                        <v-btn
                          x-small
                          color="success"
                          outlined
                          @click="editTag(file)"
                        >
                          Tag <v-icon
                            class="right"
                            x-small
                          >
                            mdi-plus
                          </v-icon>
                        </v-btn>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <v-container
            v-else
            class="fill-height"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex justify-center"
              >
                <input
                  v-show="false"
                  id="file_container"
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  class="bottom"
                  multiple
                  @change="onFilePicked"
                >
                <v-btn
                  x-large
                  icon
                  style="height:100px;width: 100px;"
                  @click="onPickFile()"
                >
                  <v-icon
                    x-large
                    style="font-size:100px"
                  >
                    mdi-image-plus
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                class="text-center"
              >
                Please upload images to view here.
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-6">
          <v-spacer />
          <v-btn
            color="error"
            outlined
            :disabled="filesList.length === 0"
            @click="clearSelectedFiles()"
          >
            Clear
          </v-btn>
          <v-btn
            color="success"
            outlined
            :disabled="filesList.length === 0"
            @click="uploadFiles();"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <TagEdit
      :show-edit-tag.sync="showEditTagDialog"
      :tag-info="tagInfo"
      @updateTag="updateTags"
    />
  </div>
</template>

<script>
import TagEdit from "./EditTag.vue";
export default {
	name: "FileUpload",
	components: {
		TagEdit
	},
	props: {
		show: { type: Boolean, default: false }
	},
	data() {
		return {
			selectedFiles: [],
			defaultTag: "new",
			showEditTagDialog: false,
			tagInfo: {},
			currentTag: ""
		};
	},
	computed: {
		showFileUpload() {
			return this.show || false;
		},
		filesList() {
			return this.selectedFiles;
		}
	},
	watch: {
		showFileUpload(v) {
			if (v) {
				this.selectedFiles = [];
			}
		}
	},
	methods: {
		close() {
			setTimeout(() => {
				this.$emit("update:show", false);
        this.$emit("fetchImages");
			}, 500);
		},
		onPickFile() {
			this.$refs.fileInput.click();
		},
		clearSelectedFiles() {
			this.selectedFiles = [];
		},
		removeSelected(index) {
			this.selectedFiles.splice(index, 1);
		},
    formImageList(files) {
      if (!files) return;
      for (let index = 0; index < files.length; index++) {
        let file = files[index];
        let fileObj = {
					refID: Math.random().toString(36).substring(2, 7),
					fileInfo: file
				};
				this.selectedFiles.push(fileObj);
      }
		},
		updateTags(tagUpd) {
			console.log({ tagUpd });
			let imgIdx = this.selectedFiles.findIndex(p => p.refID === tagUpd.refID);
			let fileInfo = this.selectedFiles[imgIdx].fileInfo;
			fileInfo["tags"] = tagUpd.tags;
			this.selectedFiles[imgIdx].fileInfo = fileInfo;
		},
		onFilePicked(event) {
			this.formImageList(event.target.files);
		},
		postImage(url, formData) {
  this.$http
    .post(url, formData)
    .then(
      (res) => {
        console.log("Upload success:", res.body);
      },
      (err) => {
        console.log("Upload error:", err.body); // shows exact backend error
      }
    );
},
		uploadFiles() {
			let accountId = this.$route.params.accountId;
			// let apiUrl = `${this.ADMIN_API_URL}/accounts/${accountId}/images?tags=`;
			// this.selectedFiles.forEach(file => {
			// 	console.log("during upd", file);
      //   if (file.fileInfo.tags){
      //     apiUrl = apiUrl + file.fileInfo.tags;
      //   }
      this.selectedFiles.forEach(file => {
       let tag = file.fileInfo.tags || "new";

       let apiUrl =
      `${this.ADMIN_API_URL}/accounts/${accountId}/images?tags=${tag}`;

				// let tagInfo =  file.fileInfo.tags || 'new';
				let formData = new FormData();
				formData.set("image", file.fileInfo);
				this.postImage(apiUrl, formData);
			});
			setTimeout(() => {
				this.selectedFiles = [];
				this.close();
			}, 500);
		},
		editTag(file) {
			console.log({ file });
			this.showEditTagDialog = true;
			this.tagInfo = {
				refID: file.refID,
				tags: file.fileInfo.tags
			};
		}
	}
};
</script>

<style>
.selected-files-cont {
  height: inherit;
  display: flex;
  /* align-items: center; */
}

.selected-file {
  width: 100%;
  word-break: break-all;
  /* height: 110px; */
  max-height: 180px;
}

.postion-top-right {
  position: absolute;
  top: 0;
  right: 0;
}

.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-upload {
  height: 550px;
}
</style>